<template>
  <DefaultLayout :loading="loading">
    <template #header>
      <div class="headerContainer">
        <h1 class="title">Crédito não disponível no momento</h1>
        <span class="subtitle">
          Não foi possível validar a sua identidade.
        </span>
      </div>
    </template>
    <template #default>
      <div class="main-container"></div>
      <div class="button-container">
        <Button theme="ame" class="button" @click="openAMEDeepLink">
          <svg
            width="23"
            height="17"
            viewBox="0 0 23 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M11.4999 4.53162C10.9836 4.53162 10.4673 4.33588
               10.0735 3.94476L6.95213 0.84419H16.0477L12.9265 3.94476C12.5327
                4.33588 12.0164 4.53162 11.4999 4.53162ZM22.3138 3.71185V3.71526L19.1626
                0.584881C18.7722 0.196996 18.2613 0.00359153 17.7495
                0.000359151V0H5.25046V0.000359151C4.73849 0.00359153 4.22777
                0.196996 3.83737 0.584881L0.686162 3.71526V3.71185C0.262361 4.13457
                 0 4.7191 0 5.36485C0 5.95494 0.218904 6.49367 0.579853 6.90472C0.584163
                 6.90957 10.0735 16.3356 10.0735 16.3356C10.4673 16.7269 10.9836 16.9224 11.4999
                  16.9226C12.0164 16.9224 12.5327 16.7269 12.9265 16.3356C12.9265 16.3356 22.4158
                   6.90957 22.42 6.90472C22.7809 6.49367 23 5.95494 23 5.36485C23 4.7191 22.7376
                   4.13457 22.3138 3.71185Z"
              fill="white"
            />
          </svg>
          Abrir aplicativo da Ame
        </Button>
      </div>
    </template>
  </DefaultLayout>
</template>

<script>
import { defineComponent, onMounted, ref, computed } from 'vue';
import { useRoute } from 'vue-router/composables';
import DefaultLayout from '@/feature/minified-onboarding/layout/DefaultLayout.vue';
import InstallmentDateSelect from '@/feature/minified-onboarding/components/InstallmentDateSelect.vue';
import Button from '@/components/ui/AppButton.vue';
import { useStore } from '@/utils/store';

export default defineComponent({
  name: 'ExpirationStepView',
  components: {
    Button,
    DefaultLayout,
    InstallmentDateSelect,
  },
  setup() {
    const store = useStore();
    const route = useRoute();
    const loading = ref(true);
    const deeplink = computed(() => store?.getters['minifiedOnboarding/deeplink']);

    async function openAMEDeepLink() {
      window.open(deeplink.value, '_blank');
    }

    onMounted(async () => {
      const { userId, onboardingToken: token, onboardingId } = route.query;

      loading.value = true;
      await store?.dispatch('auth/setToken', { token });
      await store?.dispatch('minifiedOnboarding/getOnboarding', {
        userId,
        onboardingId,
      });
      loading.value = false;
    });

    return {
      openAMEDeepLink,
      loading,
    };
  },
});
</script>

<style lang="scss" scoped>
.headerContainer {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  .title {
    display: flex;
    gap: 0.25rem;
    align-items: center;
    font-size: 1.5rem;
    line-height: 2rem;
    font-weight: 700;
  }

  .subtitle {
    font-size: 1rem;
    line-height: 1.5rem;
    color: #64748b;
  }
}

.main-container {
  display: flex;
  align-items: center;
  flex-direction: column;
  margin-top: 56px;
  height: 100%;
}

.button-container {
  display: flex;
  flex-direction: column;
  align-items: center;

  .button {
    display: flex;
    align-items: center;
    justify-content: center;
    background: #ed0059;
    font-weight: 600;
    border: none;
    color: #ffffff;
    border-radius: 24px;
    width: 100%;
    height: 48px;
    gap: 0.5rem;
  }
}
</style>
